var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper, InputSelectionList, } from '@dixa/lib-shared-habla';
import { useHookFormFieldWrapper, } from 'utils/hookForm';
/**
 * Represents the React Hook Form variant of the {@link InputSelectionList}
 * component. With a Single value.
 */
export const HookFormSelectionListSingle = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { controller, controllerProps, fieldWrapperProps } = useHookFormFieldWrapper(props);
    const _b = controller.field, { name, onBlur: onBlurController, onChange: onChangeController } = _b, controllerFieldProps = __rest(_b, ["name", "onBlur", "onChange"]);
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { children: _jsx(InputSelectionList, Object.assign({}, props.componentProps, controllerFieldProps, { multiple: false, value: controllerFieldProps.value ? [controllerFieldProps.value] : [], onBlur: (event) => {
                var _a, _b;
                (_b = (_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                onBlurController();
            }, onChange: (event) => {
                var _a, _b;
                (_b = (_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                onChangeController(event.selectedValues[0]);
            }, id: controllerProps.name, "aria-disabled": fieldWrapperProps.disabled, disabled: fieldWrapperProps.disabled, "aria-required": fieldWrapperProps.required, required: fieldWrapperProps.required, status: FieldWrapper.getStatus(fieldWrapperProps.meta) }, { children: children })) })));
};
